
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Universal Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Body Styling */
  body {
    font-family: 'Arial';
    background-color: #edd6a4; /* Soft pastel blue-grey f0f4f8. nice brown: d1c3a3*/
    color: #000; /* Dark grey text for good contrast */
    line-height: 1.6;
  }

  /* Headings Styling */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    color: #000; /* Muted dark blue for headings */
    margin-bottom: 1rem; /* Adding margin to separate headings */
  }

  /* Paragraphs Styling */
  p {
    font-size: 1.1rem; /* Slightly larger for readability */
    color: #000;
    margin-bottom: 1.5rem;
    line-height: 1.75;
  }

  /* Links Styling */
  a {
    text-decoration: none;
    color: #5c8ea3;
    transition: color 0.3s ease;
  }

  a:hover {
    color: #3e5c68;
  }

  /* Button Styling */
  button {
    font-size: 1rem;
    cursor: pointer;
    padding: 12px 24px;
    border-radius: 8px;
    background-color: #fff; /* a8d0e6 */
    color: black;
    transition: background-color 0.3s ease;
  }

  button:hover {
    background-color: #7bb8cf;
  }

  button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(118, 158, 190, 0.5);
  }

  /* Lists Styling */
  ul, ol {
    margin-left: 2rem;
    margin-bottom: 1.5rem;
  }

  /* Box Shadows for elevation effects */
  .card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  /* Container Styling */
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  /* Section Styling */
  section {
    padding: 30px;
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 2rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

export default GlobalStyle;
